import { useSelector } from 'react-redux';

export const FullAccount = () => useSelector(state => state.account);
export const ThisAccount = () => useSelector(state => state.account?.account)